import { useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authManager } from "../../data/managers/AuthManager";
import { useAuth } from "../../data/providers/AuthProvider";
import { useUserData } from "../../data/providers/UserDataProvider";
import { useWatchUserSessions } from "./useWatchUserSessions";

export function useDashboard() {
  useWatchUserSessions();
  const userData = useUserData()!;
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [mobileOpen, setMobileOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [userMenuAnchor, setUserMenuAnchor] =
    React.useState<null | HTMLElement>(null);
  const userMenuOpen = Boolean(userMenuAnchor);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  const notifications: any[] = [
    // {
    //   id: 1,
    //   title: "It's Cristina danny's birthday today.",
    //   subtitle: "2 min ago",
    //   icon: "🎁",
    //   color: "#41e396",
    //   time: "3:00 AM",
    // },
    // {
    //   id: 2,
    //   title: "Aida Burg commented your post.",
    //   subtitle: "5 August",
    //   icon: "💬",
    //   color: "#3b82f6",
    //   time: "6:00 AM",
    // },
    // {
    //   id: 38,
    //   title: "Your Profile is Complete 60%",
    //   subtitle: "7 hours ago",
    //   icon: "✅",
    //   color: "#f87171",
    //   time: "2:45 PM",
    // },
    // {
    //   id: 4,
    //   title: "Cristina Danny invited to join Meeting.",
    //   subtitle: "Daily scrum meeting time",
    //   icon: "👤",
    //   color: "#a78bfa",
    //   time: "9:10 PM",
    // },
  ];

  function handleDrawerToggle() {
    setMobileOpen((prev) => !prev);
  }

  async function handleLogout() {
    await authManager.logout();
    navigate("/login", { replace: true });
  }

  useEffect(() => {
    if (userData.data === undefined) {
      userData.reloadUserData();
    }
  }, [userData]);

  return {
    user,
    userData: userData.data,
    permittedPaths: userData.permittedPaths,
    isMobile,
    mobileOpen,
    dialogOpen,
    location,
    theme,
    open,
    anchorEl,
    notifications,
    userMenuOpen,
    userMenuAnchor,
    handleUserMenuOpen,
    handleUserMenuClose,
    handleOpen,
    handleClose,
    setMobileOpen,
    setDialogOpen,
    handleDrawerToggle,
    handleLogout,
  };
}
